import { useEffect, useState } from 'react';

export function useTypewriter(text: string, enabled: boolean, charsPerTick = 3, tickMs = 16) {
  const [count, setCount] = useState(enabled ? 0 : text.length);

  useEffect(() => {
    if (!enabled) {
      setCount(text.length);
      return;
    }
    setCount(0);
    let i = 0;
    const id = window.setInterval(() => {
      i += charsPerTick;
      setCount(Math.min(i, text.length));
      if (i >= text.length) window.clearInterval(id);
    }, tickMs);
    return () => window.clearInterval(id);
  }, [text, enabled, charsPerTick, tickMs]);

  return { output: text.slice(0, count), done: count >= text.length };
}
